import {
  FaBookOpen,
  FaBriefcase,
  FaGlobe,
  FaGraduationCap,
  FaIdCard,
  FaTrophy,
  FaUniversity,
} from "react-icons/fa";

export const PUBLIC_CATEGORIES = [
  {
    title: "Latest Jobs",
    slug: "latest-jobs",
    icon: FaBriefcase,
  },
  {
    title: "Admit Card",
    slug: "admit-card",
    icon: FaIdCard,
  },
  {
    title: "Results",
    slug: "results",
    icon: FaTrophy,
  },
  {
    title: "Admission",
    slug: "admission",
    icon: FaUniversity,
  },
  {
    title: "Scholarship",
    slug: "scholarship",
    icon: FaGraduationCap,
  },
  {
    title: "Syllabus",
    slug: "syllabus",
    icon: FaBookOpen,
  },
  {
    title: "Online Services",
    slug: "online-services",
    icon: FaGlobe,
  },
];

export const getCategoryBySlug = (slug) =>
  PUBLIC_CATEGORIES.find(
    (category) => category.slug === slug,
  );

export const getCategoryByTitle = (title) =>
  PUBLIC_CATEGORIES.find(
    (category) => category.title === title,
  );